'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JiraIconIcon = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../lib/Icon');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JiraIconIcon = exports.JiraIconIcon = function JiraIconIcon(props) {
  var _prepareProps = (0, _Icon.prepareProps)(props),
      title = _prepareProps.title,
      iconProps = _prepareProps.iconProps;

  return _react2.default.createElement(
    'svg',
    (0, _extends3.default)({ width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false' }, iconProps, { 'aria-labelledby': 'title-32p7bp9' }),
    _react2.default.createElement(
      'title',
      { id: 'title-32p7bp9' },
      title
    ),
    _react2.default.createElement('path', { d: 'M9.874 15.898c.594.626.993 1.082 1.32 1.51a.467.467 0 0 1 .04.499c-.33.616-.51 1.202-.553 1.787a.33.33 0 0 1-.326.306H8.377a.328.328 0 0 1-.327-.346c.06-1.214.49-2.422 1.324-3.702a.326.326 0 0 1 .269-.154.3.3 0 0 1 .23.1zm7.998-8.014a.339.339 0 0 1 .127.294c-.108 1.092-.536 2.154-1.308 3.273-.726 1.052-1.673 2.026-2.588 2.968-.066.07-.133.137-.198.205a.24.24 0 0 0-.016.314c.214.269.419.544.61.826.913 1.347 1.387 2.62 1.45 3.89a.33.33 0 0 1-.326.346H13.64a.327.327 0 0 1-.325-.304c-.14-1.901-1.732-3.54-3.419-5.277-.915-.941-1.862-1.916-2.588-2.968-.772-1.12-1.2-2.187-1.307-3.28a.33.33 0 0 1 .126-.29.32.32 0 0 1 .313-.045c.703.271 1.42.484 2.072.637.133.032.24.132.285.251.476 1.314 1.69 2.56 2.963 3.871.052.051.123.114.239.114.117 0 .188-.065.24-.114 1.273-1.31 2.487-2.561 2.962-3.875a.408.408 0 0 1 .285-.25c.652-.154 1.367-.36 2.071-.632a.321.321 0 0 1 .314.046zm-5.87.979c.62 0 .98-.038 1.107-.038a.304.304 0 0 1 .276.426c-.082.222-.458 1.021-1.156 1.707a.317.317 0 0 1-.229.091.317.317 0 0 1-.229-.09c-.698-.687-1.074-1.486-1.156-1.708a.304.304 0 0 1 .276-.426c.126 0 .486.038 1.107.038h.004zm3.413-3.905c.573 0 1.039.469 1.039 1.05 0 .58-.466 1.05-1.04 1.05-.574 0-1.039-.47-1.039-1.05 0-.581.465-1.05 1.04-1.05zM12 4c.574 0 1.039.469 1.039 1.05 0 .58-.465 1.05-1.04 1.05-.574 0-1.039-.47-1.039-1.05 0-.581.465-1.05 1.04-1.05zm-3.415.958c.575 0 1.04.469 1.04 1.05 0 .58-.465 1.05-1.04 1.05s-1.04-.47-1.04-1.05c0-.581.465-1.05 1.04-1.05z', fill: 'currentColor', fillRule: 'evenodd', role: 'presentation' })
  );
};
exports.default = (0, _Icon.iconConstructor)('JiraIcon', JiraIconIcon);


//////////////////
// WEBPACK FOOTER
// ./~/@atlaskit/icon/glyph/jira.js
// module id = 355
// module chunks = 0